import React, { useMemo } from "react";
import EventDetailsTable from "components/events/events/EventDetailsTable";
import columnRenderers from "security-app/components/SecurityEvents/Alerts/ColumnRenderers";
const SecurityEventDetailsTable = ({ event, attributesList }) => {
  const { attributes: attributesRenderers } = columnRenderers;
  const eventEntity = useMemo(() => {
    const { event: generalEvent, ...rest } = event;
    return { ...rest, ...generalEvent };
  }, [event]);
  return /* @__PURE__ */ React.createElement(
    EventDetailsTable,
    {
      event: eventEntity,
      attributesRenderers,
      attributesList
    }
  );
};
export default SecurityEventDetailsTable;
